module.exports = __webpack_public_path__ + "static/media/ehealth_calculator_banner_desktop.db91601f.png";